/*
defines the data structure for wiki (longer text) nodes
*/
import Node from './node';
/**
 * represents a type of node for displaying text info
 */
export default class WikiNode extends Node {
    /**
     * 
     * @param {number} id 
     * @param {Function} updateCallback 
     * @param {Object} apiSource 
     * @param {Object} apiResponse 
     * @param {string} name 
     * @param {Object} style 
     * @param {Object} source 
     * @param {string} query 
     */
    constructor(id, updateCallback = function() {}, apiSource = {}, apiResponse = {}, name, style, source, query) {
        super(id, updateCallback);
        this.apiSource = apiSource;
        this.apiResponse = apiResponse;
        this.type = 'wiki'; // TODO: check if match apiSource
        this.name = name;
        this.source = source ? source : null;
        this.style = style ? style : null;
        this.query = query ? query : null;

        // retrieve apiSource to get full api functionality of node
        if (Object.keys(this.apiSource).length < 2) {
            this.apiSource = this.getAPISource(this.style, this.source, this.query);
        }

        this.text = this.getText();
    }

    /**
     * gets the main text content from the API response
     * @return {string}
     */
    getText() {
        let text;
        if (this.name === 'DB') {
            text = this.apiSource.text(this.apiResponse);
        } else if (!this.apiResponse || Object.keys(this.apiResponse).length === 0) {
            this.setUpdateCallback(this.updateCallback);
            text = null;
        } else {
            text = this.apiSource.text(this.apiResponse);
        }

        this.text = text;
        return text;
    }
}
